import React from 'react';
import { Text } from '@spark';

export default function ModelDetailsSectionTitle({ children, style, variant = 'heading-3-semibold' }) {
  return (
    <Text
      variant={variant}
      as="h3"
      style={{
        marginTop: 0,
        marginBottom: 12,
        color: '#111827',
        ...(style || {}),
      }}
    >
      {children}
    </Text>
  );
}
